import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p>© 2024 Valiosaliada - Construção e Pintura Lda. Todos os direitos reservados</p>
      </div>
    </footer>
  );
};

export default Footer;